var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient1",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0.14%",
    stopColor: "#FF8E08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "11.87%",
    stopColor: "#FDFFB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "23.15%",
    stopColor: "#FFED4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54.37%",
    stopColor: "#FBE4A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "74.22%",
    stopColor: "#F8D185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "79.32%",
    stopColor: "#E66606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "86.96%",
    stopColor: "#FCF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF7629"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 12L5 12M19 12L13 18M19 12L13 6",
    stroke: "url(#Gradient1)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.43e5ac7726b4c5ce861f3b98cf755657.svg";
export { ForwardRef as ReactComponent };